import { ReactNode } from "react";

import {
  Box,
  Divider,
  Popover,
} from "@mui/material";

interface SearchablePopoverContentProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  search: ReactNode;
  children: ReactNode;
  width?: number;
}

export const SearchablePopoverContent = ({
  anchorEl,
  open,
  onClose,
  search,
  children,
  width = 360,
}: SearchablePopoverContentProps) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          width,
          maxHeight: 450,
          mt: 0.5,
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: 1.5 }}>
        {search}
      </Box>

      <Divider />

      <Box
        sx={{
          maxHeight: 350,
          overflowY: "auto",
        }}
      >
        {children}
      </Box>
    </Popover>
  );
};